import React from "react";
import ImageLazyLoad from "../../../general/loading/ImageLazyLoad";
import {Button} from "../../../general/input/Button";
import "../../../account/style/ordering.css"
import {uomService} from "../../../../res/dataServices/uom";
import {formatDisplayPrice} from "../../../../res/dataServices/pricing";
import HeaderLink from "./HeaderLink";
import CompactInvoice from "./CompactInvoice";
import CompactShipment from "./CompactShipment";

const getActions = (orderLine) => {
    const actions = [];
    if(orderLine.isBackOrder) {
        actions.push({name: "Cancel Back Order", onClick: () => console.log("cancel")})
    }
    return actions;
}

const DetailItem = ({heading, headingStyle, body}) => {

    return (
        <>
            <p className="placed-order-detail-h" style={{...headingStyle}}>{heading}</p>
            <p className="placed-order-detail-b">{body}</p>
        </>
    )
}

const Details = ({orderLine}) => {

    const product = orderLine["M_Product_ID"];
    const productName = product.Name;
    const productCode = product.Value;

    const uomQuantity = uomService.uomQuantity(orderLine["C_UOM_ID"]);
    const ordered = uomQuantity.getDisplayName(orderLine.QtyEntered);
    const price = formatDisplayPrice(orderLine.LineNetAmt);

    return (
        <div className="placed-order-line-details">
            <DetailItem heading={productCode}
                        headingStyle={{fontSize: "1em", fontWeight: "500", color:"var(--primary)"}}
                        body={productName}/>
            <DetailItem heading="Quantity" body={ordered}/>
            <DetailItem heading={"Total"} body={price}/>
        </div>
    )
}

const LineOrder = ({orderLine, invoices, shipments}) => {

    const actions = getActions(orderLine);

    const product = orderLine["M_Product_ID"];
    const productImg  = product?.ImageURL;

    return (
        <div className="tile">
            <div className="tile-header placed-order-line-header">
                <p style={{marginRight: "auto"}}>line: {orderLine.Line}</p>
                <HeaderLink txt={"Invoice(s)"}>
                    {invoices ? invoices.map((e,i) => <CompactInvoice key={i} invoice={e}/>)
                        : <p className={"account-link-empty"}>There are no invoices linked to this order line</p> }
                </HeaderLink>
                <HeaderLink txt={"Shipment(s)"}>
                    {shipments ? shipments.map((e,i) => <CompactShipment key={i} shipment={e}/>)
                        : <p className={"account-link-empty"}>There are no shipments linked to this order line</p> }
                </HeaderLink>
            </div>
            <div className="tile-2-body placed-order-line-body">
                <ImageLazyLoad
                    className={"placed-order-line-img"}
                    src={productImg}
                    alt="Product"
                />
                <Details orderLine={orderLine} />
                <div className="placed-order-line-info">
                    {orderLine.info && orderLine.info.map((info,i) =>
                        <p key={i} className="info">
                            {info}
                        </p>
                    )}
                </div>
                <div className="placed-order-line-actions">
                    {actions.map((e,i) =>
                        <Button key={i}>{e.name}</Button>
                    )}
                </div>
            </div>
        </div>
    )

}

export default LineOrder;